<template>
    <div class="modal fade bd-example-modal-lg" id="hotel-modal" tabindex="-1" role="dialog"
        data-backdrop="static" aria-labelledby="hotelModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
          <h5 class="modal-title">{{hotel.Name}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-optionals">
            <div class="form-row">
                <div :class="{'col-md-7': images.length>0, 'col-md-12': images.length==0}">
                  <text-rows-style classStyle="text-justify" tag="p" :text="description" v-if="description"
                  ></text-rows-style>
                  <ul>
                  </ul>
                </div>
                <div class="col-md-5 image optional-image" v-if="images.length>0">
                    <lin-gallery :items="images" v-if="images.length>1" :height="200"></lin-gallery>
                    <async-img :url="images[0].src" class="d-block w-100" v-else-if="images.length==1"></async-img>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
const escape = importVueComp('components/tools', 'Escape');
const linGallery = importVueComp('components/tools', 'LinGallery');
export default {
    name: 'hotel-modal',
    mixins: [escape],
    components: {
      'lin-gallery': linGallery,
    },
    props: ['hotel'],
    mounted () {
        $('#hotel-modal').modal({backdrop: 'static', keyboard: false}, 'show');
    },
    methods: {
        close () {
            this.$emit('update:hotel', null);
            $('#hotel-modal').modal('hide');
        },
    },
    computed:{
        images () {
            let res = [];
            for (let image of this.hotel.HotelPhotos) {
                if (!image.Image) continue;
                res.push({id: image.ImageId, src: image.Image.url, thumbnail: image.Image.url});
            }
            return res;
        },
        description () {
            if (!this.hotel) return;
            let t = _.find(this.hotel.HotelDescriptions, (c) => c.Language.Code=='en');
            if (t) return t.Description;
            return '';

        }
    },
}
</script>


